import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

interface IngestionTypeIconProps {
  ingestionId: 'DECLARATIVE' | 'SIFFLET_SOURCED';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Ingestion-Type-Icon',
  props: {
  ingestionId: null
},
  setup(__props) {

const props = __props;


const icon = _computed(() => {
  switch (props.ingestionId) {
    case 'DECLARATIVE':
      return 'icon-data-source-declarative';
    default:
      return 'icon-data-source';
  }
});

return { __sfc: true,props, icon, _computed }
}

})